import { useTranslation } from "react-i18next";

import ListActions from "../../yoello-lib/modules/components/UI/ListActions";

import { OrderListHeaders } from "../orders/OrderList/OrderListViewHeaders";
import { groupColumns } from "./columns";
import { List } from "./ui/List"
import { useStyles } from "./styles"

import { useVenueGroups } from "./useVenueGroups";
import { Route, useRouteMatch } from "react-router-dom";
import { BY_ID } from "../../const/URL.const";
import { DialogRoute } from "../dialogRoutes/DialogRoute";
import { GroupFormDialog } from "./GroupFormDialog";
import { IVenueGroup } from "./state/groupsManagement.reducer";


interface IGroupsListView{
  dispatch:any,
  groups:IVenueGroup[]
}

export function GroupsListView({ dispatch, groups }: IGroupsListView) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { path } = useRouteMatch();
 
  const { 
    setSearchText, 
    callGroups, 
    onCreateGroup, 
    onSelectGroup, 
    searchIsLoading, 
    isGroupsLoading, 
    setGroupsListItems } = useVenueGroups( dispatch, path );

  const searchProps = {
    placeholder: t("groups.search.placeholder"),
    setSearchText: setSearchText,
    isLoading:searchIsLoading,
    isAutoComplete:false
  }
  const createProps = {
    title:t("groups.buttons.createGroup"),
    onClick:onCreateGroup
  }

  return (
    <Route path={path}>
        <div className={classes.controlers}>
            <ListActions  hasSearch={searchProps} hasCreate={createProps}/>
        </div>
        <div className={classes.listWrapper} data-component-name="GroupSettingsListContainer">
            <div key={`groupSettingsHeaders-groupSettingsItems`} className={classes.columnsHeader}>
                {groupColumns.map((column) => <OrderListHeaders {...column} key={`col-${column.key}-${column.label}`} />)}
            </div>
            <List groups={groups} onClick={onSelectGroup} isLoading={isGroupsLoading}/>
        </div>

        <Route path={`${path}${BY_ID}`}>
          <DialogRoute
            Component={GroupFormDialog}
            ComponentPropsFunctions={{
              callGroupsAPI:callGroups,
              setGroupsListItems
            }}
            navigateBackRoute={path}
            dialogClassName={classes.dialogContainer}
            dialogTitle={t('groups.buttons.createGroup')}
          />
        </Route>
    
    </Route>
  )
}
